export const NavBarAllowedExecuteFields = {
  ActionButtonExecute: () => import("./ActionButtonExecute"),

}
